import { normalizeUsZipCodeFiveDigits } from '@/lib/address-duplicate';

/**
 * Places `input` for address autocomplete. The visible Address field stays
 * as typed; ZIP from the Zip Code field is appended so predictions bias to
 * that area (e.g. "farmingdale" + 11735 → "farmingdale 11735").
 */
export function buildPlacesAutocompleteInput(
  query: string,
  zipcode?: string
): string {
  const trimmedQuery = query.trim();
  if (!trimmedQuery) {
    return '';
  }
  const zip = normalizeUsZipCodeFiveDigits(zipcode ?? '').trim();
  if (!zip || trimmedQuery.includes(zip)) {
    return trimmedQuery;
  }
  return `${trimmedQuery} ${zip}`;
}
